import { useState } from "react";
import { Box } from "@mui/material";
import MessageView from "./MessageView";
import MessagesList from "./MessagesList";
import ConversationThread from "./ConversationThread";
import useMessagesAPIClient from "../../api/messages/hooks/useMessagesAPIClient";
import { useDispatch, useSelector } from "react-redux";
import { markMessageAsRead } from "../../redux/actions/messages";

const MessageMobile = () => {
  const [activePanel, setActivePanel] = useState("list");
  const [activeMessageId, setActiveMessageId] = useState(null);
  const messages = useSelector((state) => state.messages);
  const { markMessageAsRead: markMessageAsReadAPICall } =
    useMessagesAPIClient();
  const dispatch = useDispatch();

  const onMessageClick = async (messageId) => {
    setActiveMessageId(messageId);
    setActivePanel("message");

    // If message is already read do not dispatch or call API
    const message = messages.find((msg) => msg.messageId === messageId);
    if (message.read) {
      return;
    }
    dispatch(markMessageAsRead(messageId));
    await markMessageAsReadAPICall(messageId);
  };

  const onConversationClick = () => {
    setActivePanel("conversation");
  };

  return (
    <Box className="messages--mobile">
      {activePanel === "list" && (
        <MessagesList
          onMessageClick={onMessageClick}
          activeMessageId={activeMessageId}
          onConversationClick={onConversationClick}
          conversationActive={false}
        />
      )}
      {activePanel === "message" && (
        <MessageView
          activeMessageId={activeMessageId}
          goBack={() => setActivePanel("list")}
        />
      )}
      {activePanel === "conversation" && (
        <ConversationThread goBack={() => setActivePanel("list")} />
      )}
    </Box>
  );
};

export default MessageMobile;
